export default __webpack_public_path__ + "static/media/CERTIFICADO_HALU_0000_Instituto-dos-Mistérios-Ascensionais.0d1f7379.png";